export default function DocsSynopsis(){
  return(
    <div>
      Document Synopsis coming soon! 
    </div>
  );
}